import _ from '../locale';
import { DataType } from '../types';
import {
    CAUSE_ID_KEY,
    COVARIATE_ID_KEY,
    COVID19_ID_KEY,
    CRO_ID_KEY,
    INDICATOR_ID_KEY,
    LIFE_EXPECTANCY_ID_KEY,
    OUTCOME_ID_KEY,
    PATHOGEN_ID_KEY,
    POPULATION_ID_KEY,
    REI_ID_KEY,
    SDOH_ID_KEY,
    SEQUELA_ID_KEY,
    VEHSS_CONDITION_ID_KEY,
} from './data-key';
import {
    AntimicrobialResistanceRecords,
    CauseAssociatedComorbidityStudyCoefficients,
    CauseAssociatedCoprevalenceRecords,
    CauseCoprevalenceRecords,
    CauseOutcome,
    CovariateRecords,
    Covid19Records,
    CroRecords,
    EDPOnetimeIndicators,
    EDPTimelineIndicators,
    EtiologyRecords,
    ExpenditureRecords,
    HealthThreatsMetricsRecords,
    ImpairmentRecords,
    InjuryRecords,
    LifeExpectancyRecords,
    MultipleMyelomaOutputShell,
    MultipleMyelomaPopulation,
    MultipleMyelomaSurvivalResults,
    PopulationRecords,
    ProjectedComorbidityCausesOutcomeRecords,
    RaceEthnicityEyeConditionsRecords,
    RiskAttribution,
    RiskExposureRecords,
    RiskPrevalence,
    SdohRecords,
    SequelaOutcome,
    SevRecords,
    TakedaDengueRecords,
} from './data-type';

export const getDataTypeConfig = () => ({
    [CauseOutcome]: {
        groupLabel: _('causes'),
        filterKey: CAUSE_ID_KEY,
        localePrefix: 'cause_',
        entityHierarchyKey: 'causes',
    },
    [SequelaOutcome]: {
        groupLabel: _('sequelas'),
        filterKey: SEQUELA_ID_KEY,
        localePrefix: 'sequela_',
        entityHierarchyKey: 'sequelas',
    },
    [RiskAttribution]: {
        groupLabel: _('risks'),
        filterKey: REI_ID_KEY,
        localePrefix: 'rei_',
        entityHierarchyKey: 'risks',
    },
    [RiskPrevalence]: {
        groupLabel: _('risks'),
        filterKey: REI_ID_KEY,
        localePrefix: 'rei_',
        entityHierarchyKey: 'risks',
    },
    [RiskExposureRecords]: {
        groupLabel: _('riskExposures'),
        filterKey: REI_ID_KEY,
        localePrefix: 'rei_',
    },
    [EtiologyRecords]: {
        groupLabel: _('etiologies'),
        filterKey: REI_ID_KEY,
        localePrefix: 'rei_',
        entityHierarchyKey: 'etiologies',
    },
    [ImpairmentRecords]: {
        groupLabel: _('impairments'),
        filterKey: REI_ID_KEY,
        localePrefix: 'rei_',
        entityHierarchyKey: 'impairments',
    },
    [InjuryRecords]: {
        groupLabel: _('injuries'),
        filterKey: REI_ID_KEY,
        localePrefix: 'rei_',
        entityHierarchyKey: 'injuries',
    },
    [SevRecords]: {
        groupLabel: _('sev'),
        filterKey: REI_ID_KEY,
        localePrefix: 'rei_',
        entityHierarchyKey: 'sevs',
    },
    [TakedaDengueRecords]: {
        groupLabel: _('data_type_takeda_dengue_records'),
        filterKey: OUTCOME_ID_KEY,
        localePrefix: OUTCOME_ID_KEY.slice(0, -2),
    },
    [CovariateRecords]: {
        groupLabel: _('covariates'),
        filterKey: COVARIATE_ID_KEY,
        localePrefix: 'covariate_',
    },
    [SdohRecords]: {
        groupLabel: _('sdohs'),
        filterKey: SDOH_ID_KEY,
        localePrefix: 'sdoh_',
    },
    [PopulationRecords]: {
        groupLabel: _('population'),
        filterKey: POPULATION_ID_KEY,
        localePrefix: 'population_',
    },
    [Covid19Records]: {
        groupLabel: _('covid19'),
        filterKey: COVID19_ID_KEY,
        localePrefix: 'covid19_',
    },
    [CauseCoprevalenceRecords]: {
        groupLabel: _('data_type_cause_coprevalence_records'),
        filterKey: CAUSE_ID_KEY,
        localePrefix: 'cause_',
        entityHierarchyKey: 'causes',
    },
    [ProjectedComorbidityCausesOutcomeRecords]: {
        groupLabel: _('data_type_projected_comorbidity_causes_outcome_records'),
        filterKey: CAUSE_ID_KEY,
        localePrefix: 'cause_',
        entityHierarchyKey: 'causes',
    },
    [CauseAssociatedCoprevalenceRecords]: {
        groupLabel: _('data_type_cause_associated_coprevalence_records'),
        filterKey: CAUSE_ID_KEY,
        localePrefix: 'cause_',
        entityHierarchyKey: 'causes',
    },
    [CauseAssociatedComorbidityStudyCoefficients]: {
        groupLabel: _('data_type_cause_associated_comorbidity_study_coefficients'),
        filterKey: CAUSE_ID_KEY,
        localePrefix: 'cause_',
        entityHierarchyKey: 'causes',
    },
    [EDPOnetimeIndicators]: {
        groupLabel: _('data_type_early_detection_onetime_indicators'),
        filterKey: INDICATOR_ID_KEY,
        localePrefix: 'indicator_',
    },
    [EDPTimelineIndicators]: {
        groupLabel: _('data_type_early_detection_timeline_indicators'),
        filterKey: INDICATOR_ID_KEY,
        localePrefix: 'indicator_',
    },
    [LifeExpectancyRecords]: {
        groupLabel: _('data_type_life_expectancy_records'),
        filterKey: LIFE_EXPECTANCY_ID_KEY,
        localePrefix: 'life_expectancy_',
    },
    [AntimicrobialResistanceRecords]: {
        groupLabel: _('data_type_antimicrobial_resistance_records'),
        filterKey: PATHOGEN_ID_KEY,
        localePrefix: 'pathogen_',
    },
    [MultipleMyelomaPopulation]: {
        groupLabel: _('data_type_multiple_myeloma_population_records'),
        filterKey: POPULATION_ID_KEY,
        localePrefix: 'population_',
    },
    [MultipleMyelomaSurvivalResults]: {
        groupLabel: _('data_type_multiple_myeloma_survival_results'),
        filterKey: CAUSE_ID_KEY,
        localePrefix: 'cause_',
    },
    [MultipleMyelomaOutputShell]: {
        groupLabel: _('data_type_multiple_myeloma_output_shell'),
        filterKey: CAUSE_ID_KEY,
        localePrefix: 'cause_',
    },
    [HealthThreatsMetricsRecords]: {
        groupLabel: _(`data_type_${HealthThreatsMetricsRecords}`),
        filterKey: CAUSE_ID_KEY,
        localePrefix: 'cause_',
    },
    [RaceEthnicityEyeConditionsRecords]: {
        groupLabel: _(`data_type_${RaceEthnicityEyeConditionsRecords}`),
        filterKey: VEHSS_CONDITION_ID_KEY,
        localePrefix: 'vehss_condition_',
        entityHierarchyKey: 'vehss',
    },
    [ExpenditureRecords]: {
        groupLabel: _(`data_type_${ExpenditureRecords}`),
        filterKey: CAUSE_ID_KEY,
        localePrefix: 'cause_',
        entityHierarchyKey: 'causes',
    },
    [CroRecords]: {
        groupLabel: _(`data_type_${CroRecords}`),
        filterKey: CRO_ID_KEY,
        localePrefix: 'cro_',
        entityHierarchyKey: 'cros',
    },
});

let dataFilterToDataTypeMapCache: Partial<Record<string, DataType[]>> | null = null;

export const getDataFilterToDataTypeMap = (): Partial<Record<string, DataType[]>> => {
    if (dataFilterToDataTypeMapCache !== null) {
        return dataFilterToDataTypeMapCache;
    }
    const config = getDataTypeConfig();
    const map: Partial<Record<string, DataType[]>> = {};
    Object.entries(config).forEach(([dataType, { filterKey }]) => {
        if (!map[filterKey]) {
            map[filterKey] = [];
        }
        map[filterKey]!.push(dataType as DataType);
    });
    dataFilterToDataTypeMapCache = map;
    return map;
};
